import type { ReactNode } from "react";

export type ProductIconName =
  | "clean"
  | "stems"
  | "mastering"
  | "lyrics"
  | "artwork"
  | "video"
  | "sell"
  | "super"
  | "enhancedAlbum"
  | "labels";

export const productIcons: Record<ProductIconName, ReactNode> = {
  clean: (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M15.833 17.5 10 11.667l-1.958 1.958q.165.312.229.667.062.354.062.708a3.2 3.2 0 0 1-.979 2.354 3.2 3.2 0 0 1-2.354.98 3.2 3.2 0 0 1-2.354-.98A3.2 3.2 0 0 1 1.666 15q0-1.375.98-2.354A3.2 3.2 0 0 1 5 11.666q.354 0 .708.063t.667.23L8.333 10 6.375 8.042q-.312.165-.667.229A4 4 0 0 1 5 8.333a3.2 3.2 0 0 1-2.354-.979A3.2 3.2 0 0 1 1.666 5q0-1.375.98-2.354A3.2 3.2 0 0 1 5 1.666a3.2 3.2 0 0 1 2.354.98A3.2 3.2 0 0 1 8.334 5q0 .354-.063.708a2.2 2.2 0 0 1-.23.667l10.292 10.292v.833zM12.5 9.167 10.833 7.5l5-5h2.5v.833zM5 6.667q.687 0 1.177-.49T6.667 5t-.49-1.177A1.6 1.6 0 0 0 5 3.333q-.687 0-1.177.49T3.333 5t.49 1.177T5 6.667m5 3.75a.4.4 0 0 0 .292-.125.4.4 0 0 0 0-.584.4.4 0 0 0-.584 0 .4.4 0 0 0 0 .584.4.4 0 0 0 .292.125m-5 6.25q.687 0 1.177-.49T6.667 15t-.49-1.177A1.6 1.6 0 0 0 5 13.333q-.687 0-1.177.49T3.333 15t.49 1.177 1.177.49" />
    </svg>
  ),
  stems: (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M10 11 1 6.5 10 2l9 4.5zm0 3.5-8.5-4.25 1.667-.833L10 12.812l6.833-3.395 1.667.833zm0 3.5-8.5-4.25 1.667-.833L10 16.312l6.833-3.395 1.667.833zM10 9.313 15.646 6.5 10 3.688 4.354 6.5z" />
    </svg>
  ),
  mastering: (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M10 3.333A6.667 6.667 0 0 0 3.333 10h2.5A1.667 1.667 0 0 1 7.5 11.667v4.166A1.667 1.667 0 0 1 5.833 17.5h-2.5a1.667 1.667 0 0 1-1.666-1.667V10a8.333 8.333 0 1 1 16.666 0v5.833a1.667 1.667 0 0 1-1.666 1.667h-2.5a1.667 1.667 0 0 1-1.667-1.667v-4.166A1.666 1.666 0 0 1 14.167 10h2.5A6.667 6.667 0 0 0 10 3.333m-6.667 8.334v4.166h2.5v-4.166zm10.834 0v4.166h2.5v-4.166z" />
    </svg>
  ),
  lyrics: (
    <svg
      viewBox="0 0 22 22"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2.199 19.8V3.85c0-.454.162-.842.485-1.166A1.59 1.59 0 0 1 3.849 2.2h9.9c.454 0 .842.162 1.166.484.323.324.484.712.484 1.166v.595a4.7 4.7 0 0 0-1.65 1.673V3.85h-9.9v11.962l.963-.962h8.937v-4.469c.412.73.962 1.288 1.65 1.673v2.796c0 .453-.161.842-.484 1.165a1.59 1.59 0 0 1-1.166.484h-8.25zM5.5 13.2h3.3v-1.65H5.5zm12.1-2.2a2.65 2.65 0 0 1-1.948-.802 2.65 2.65 0 0 1-.802-1.948c0-.764.267-1.413.802-1.948A2.65 2.65 0 0 1 17.6 5.5c.306 0 .673.076 1.1.229V1.1H22v1.65h-1.65v5.5c0 .764-.267 1.413-.802 1.948A2.65 2.65 0 0 1 17.6 11M5.5 10.175h6.6v-1.65H5.5zm0-3.025h6.6V5.5H5.5z" />
    </svg>
  ),
  artwork: (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M7.796 11.469h7.345l-2.534-3.305-1.69 2.203L9.78 8.898zm-.734 2.938q-.606 0-1.037-.432a1.41 1.41 0 0 1-.432-1.037V4.124q0-.606.432-1.037a1.41 1.41 0 0 1 1.037-.432h8.813q.606 0 1.038.432.43.432.431 1.037v8.814q0 .606-.431 1.037a1.41 1.41 0 0 1-1.038.431zm0-1.47h8.813V4.125H7.062zm-2.938 4.407q-.606 0-1.037-.431a1.42 1.42 0 0 1-.432-1.038V5.593h1.47v10.282h10.281v1.47z" />
    </svg>
  ),
  video: (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M9.5 12 15 8.5 9.5 5zM6.5 15c-.413 0-.766-.147-1.059-.441A1.44 1.44 0 0 1 5 13.5v-10c0-.413.147-.766.441-1.059A1.44 1.44 0 0 1 6.5 2h10c.413 0 .766.147 1.059.441.294.293.441.646.441 1.059v10c0 .413-.147.766-.441 1.059A1.44 1.44 0 0 1 16.5 15zm0-1.5h10v-10h-10zM3.5 18c-.413 0-.766-.147-1.059-.441A1.44 1.44 0 0 1 2 16.5V5h1.5v11.5H15V18z" />
    </svg>
  ),
  sell: (
    <svg
      viewBox="0 0 22 22"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18.7 10.45v6.592c0 .456-.162.846-.485 1.171a1.59 1.59 0 0 1-1.165.487H4.95c-.454 0-.842-.164-1.166-.493a1.63 1.63 0 0 1-.484-1.157v-6.623c-.504-.352-.821-.802-.951-1.352a3.7 3.7 0 0 1 .011-1.742L3.414 4.4c.077-.367.252-.642.527-.825s.609-.275 1.001-.275h12.115c.392 0 .722.084.989.252.268.168.447.45.539.848l1.054 2.933c.138.611.138 1.192 0 1.742a2.29 2.29 0 0 1-.939 1.375M13.016 9.35c.321 0 .592-.107.814-.321.221-.214.317-.474.286-.779l-.55-3.3h-1.65v3.291c0 .312.107.574.321.788s.474.321.779.321m-4.045 0c.314 0 .577-.107.791-.321s.321-.476.321-.788V4.95h-1.65l-.55 3.3c-.031.305.065.565.286.779.222.214.489.321.802.321m-4.021 0c.275 0 .515-.084.721-.252.207-.168.325-.382.356-.642L6.6 4.95H4.95L3.918 7.883a1.15 1.15 0 0 0 .138.997c.214.313.512.47.894.47m12.1 0c.382 0 .683-.157.905-.47a1.15 1.15 0 0 0 .149-.997L17.05 4.95H15.4l.573 3.506c.03.26.153.474.367.642.214.168.45.252.71.252M4.95 17.05h12.1V11c-.382 0-.745-.073-1.089-.218a2.9 2.9 0 0 1-.928-.676 2.9 2.9 0 0 1-.925.676 2.8 2.8 0 0 1-1.092.218c-.385 0-.744-.076-1.079-.229a3.1 3.1 0 0 1-.937-.665 3.1 3.1 0 0 1-.917.665A2.7 2.7 0 0 1 8.983 11c-.382 0-.741-.065-1.077-.195a2.9 2.9 0 0 1-.94-.699 3.3 3.3 0 0 1-.997.694c-.328.133-.668.2-1.019.2z" />
    </svg>
  ),
  super: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="m12 2 2.09 6.26L20 10l-5.91 1.74L12 18l-2.09-6.26L4 10l5.91-1.74zm7 14 .9 2.1L22 19l-2.1.9L19 22l-.9-2.1L16 19l2.1-.9z" />
    </svg>
  ),
  enhancedAlbum: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m3 9 9 4 9-4-9-4-9 4Z" />
        <path d="m3 9 4.5-5L12 5l4.5-1L21 9" />
        <path d="M3 9v8l9 4 9-4V9M12 13v8" />
        <path d="m7.5 4 4.5 5 4.5-5" />
      </g>
    </svg>
  ),
  labels: (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="6.5" cy="7" r="2.25" />
        <circle cx="17.5" cy="7" r="2.25" />
        <path d="M2.5 17.75v-.85c0-2.55 1.78-4.5 4-4.5 1.2 0 2.28.5 3 1.4" />
        <path d="M21.5 17.75v-.85c0-2.55-1.78-4.5-4-4.5-1.2 0-2.28.5-3 1.4" />
        <circle cx="12" cy="9" r="3" />
        <path d="M6.5 21v-1.5c0-3.1 2.46-5.5 5.5-5.5s5.5 2.4 5.5 5.5V21" />
      </g>
    </svg>
  ),
};
